import { render, staticRenderFns } from "./card-chip-avatar.vue?vue&type=template&id=89e751b4"
import script from "./card-chip-avatar.vue?vue&type=script&lang=ts"
export * from "./card-chip-avatar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89e751b4')) {
      api.createRecord('89e751b4', component.options)
    } else {
      api.reload('89e751b4', component.options)
    }
    module.hot.accept("./card-chip-avatar.vue?vue&type=template&id=89e751b4", function () {
      api.rerender('89e751b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/legacy/card/card-chip-avatar.vue"
export default component.exports